/*=============================
=         Testimonials        =
=============================*/


var testimonialFilterBar = document.querySelector('.testimonialFilterBar'),
    filterBarItem = testimonialFilterBar.getElementsByTagName('a');

function filterSelection(c) {
    var x, i;
    x = document.querySelectorAll(".testimonialItem");
    if (c == "all") c = "";
    Array.from(x).forEach(item => {
        removeActiveClass(item, "show");
        if (item.className.indexOf(c) > -1) addActiveClass(item, "show");
    });
}
function addActiveClass(ele, name) {
    var i, arr1, arr2;
    arr1 = ele.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
        if (arr1.indexOf(arr2[i]) == -1) {
            ele.className += " " + arr2[i];
        }
    }
}
function removeActiveClass(ele, name) {
    var i, arr1, arr2;
    arr1 = ele.className.split(" ");
    arr2 = name.split(" ");
    for (i = 0; i < arr2.length; i++) {
        while (arr1.indexOf(arr2[i]) > -1) {
            arr1.splice(arr1.indexOf(arr2[i]), 1);
        }
    }
    ele.className = arr1.join(" ");
}

for (var i = 0; i < filterBarItem.length; i++) {
    filterBarItem[i].addEventListener("click", function() {
        var current = testimonialFilterBar.getElementsByClassName("active");
        current[0].className = current[0].className.replace(" active", "");
        this.className += " active";

        filterSelection(this.getAttribute('data-source'))
    });
}
filterSelection('all');
